import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const getBackgroundSizeOptions = ({
  defaultValue = "cover",
}: {
  defaultValue?: string;
} = {}): StyleValue => ({
  type: "select",
  value: defaultValue,
});

export const getBackgroundImageOptions = ({
  defaultValue = {
    placeholder: "",
    signed_id: "",
  },
}: {
  defaultValue?: {
    placeholder?: string;
    signed_id: string;
  };
} = {}): StyleValue => ({
  type: "background-image",
  value: defaultValue,
});
